import { RESET_STATE } from 'store/global/actions';

import { SUBJECT_PROPERTY_ACTION_TYPE } from '../actions';

const initialState = null;

const subjectPropertyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUBJECT_PROPERTY_ACTION_TYPE.GET_PROPERTY:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default subjectPropertyReducer;
